import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { inject } from "@vercel/analytics";
import { injectSpeedInsights } from "@vercel/speed-insights";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
inject();
injectSpeedInsights();
